function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M7.72 1.161a.526.526 0 0 1 .759.73L5.192 5.308a.526.526 0 0 1-.758 0L1.147 1.89a.526.526 0 1 1 .758-.729l2.908 3.024L7.72 1.161z"
});

var SvgArrowDownIcon = function SvgArrowDownIcon(props) {
  return React.createElement("svg", _extends({
    width: 9,
    height: 6
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5IiBoZWlnaHQ9IjYiIHZpZXdCb3g9IjAgMCA5IDYiPgogICAgPHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iLjMiIGQ9Ik03LjcyIDEuMTYxYS41MjYuNTI2IDAgMCAxIC43NTkuNzNMNS4xOTIgNS4zMDhhLjUyNi41MjYgMCAwIDEtLjc1OCAwTDEuMTQ3IDEuODlhLjUyNi41MjYgMCAxIDEgLjc1OC0uNzI5bDIuOTA4IDMuMDI0TDcuNzIgMS4xNjF6Ii8+Cjwvc3ZnPgo=";
export { SvgArrowDownIcon as ReactComponent };